import styled from 'styled-components';

export const SearchContainerStyle = styled.div`
    display: flex;
    margin: auto;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top: 8%;
    gap: 40px;
`